import { isLive } from '../../Utils/Utilities';
import { useState, useEffect } from 'react';
import { Carousel, CarouselContent, CarouselItem } from '../../Components/UI/carousel';

const AboutUs = () => {
	const [api, setApi] = useState(null);
	const [current, setCurrent] = useState(0);

	const imageSlides = [
		'/Web/assets/Images/Landing/Team1.jpeg',
	];

	useEffect(() => {
		if (!api) return;
		setCurrent(api.selectedScrollSnap());
		api.on('select', () => {
			setCurrent(api.selectedScrollSnap());
		});
		const interval = setInterval(() => api.scrollNext(), 4000);
		return () => clearInterval(interval);
	}, [api]);

	return (
		<section
			className='py-12 md:py-16 pl-6 pr-6 md:pl-12 md:pr-6 bg-white overflow-hidden'
		>
			<div className="max-w-[80%] mx-auto">
				<h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center -mb-4 sm:mb-4 md:mb-6 xl:mb-8 text-gray-800">
					About Us
				</h2>
				<div className="grid lg:grid-cols-2 gap-8 md:gap-9 items-center">
					<div className="order-1 lg:order-1 overflow-hidden md:mx-0 rounded-md">
						<Carousel
							setApi={setApi}
							opts={{ loop: true, align: 'center' }}
							className="w-full"
						>
							<CarouselContent className="-ml-1">
								{imageSlides.map((src, idx) => (
									<CarouselItem key={idx} className="pl-1">
										<div className="flex items-center justify-center w-full h-[220px] xs:h-[280px] sm:h-[300px] md:h-[340px] lg:h-[420px] xl:h-[490px] rounded-lg overflow-hidden bg-gradient-to-b from-sahi-green/5 to-sahi-green/10">
											<img
												src={isLive() ? src : src.replace('/Web', '')}
												alt={`About us ${idx + 1}`}
												className="max-w-full max-h-full object-contain rounded-lg"
											/>
										</div>
									</CarouselItem>
								))}
							</CarouselContent>
						</Carousel>
						{/* Dots Indicator */}
						{/* <div className="flex justify-center space-x-2 xs:mt-4 lg:mt-2">
							{imageSlides.map((_, i) => (
								<button
									key={i}
									onClick={() => api?.scrollTo(i)}
									aria-label={`Go to slide ${i + 1}`}
									className={`transition-all duration-300 rounded-full ${i === current ? 'bg-sahi-green w-8 h-2' : 'bg-gray-300 w-2 h-2'}`}
								/>
							))}
						</div> */}
					</div>
					<div className="order-2 lg:order-2 space-y-6 text-center lg:text-left">
						<div className="space-y-4 text-gray-700">
							<p className="text-sm md:text-base lg:text-xl leading-relaxed">
								<span >SahiClub</span> is a
								creation of <strong>Biziverse Pvt. Ltd.</strong>, based in
								<strong> Gandhinagar</strong>, Gujarat in India. It is a part of the{' '}
								<strong>Peach</strong> group (est.<strong> 1985</strong>), with a strong
								reputation in Electronics, E-Governance, and Enterprise
								Software, and a customer base of more than{' '}
								<strong>45,000</strong> businesses, non-profits, and government
								organizations.
							</p>
							<p className="text-sm md:text-base lg:text-xl leading-relaxed">
								Our mantra is{' '}
								<strong >
									“Make every Small Business a Smart Business!”
								</strong>{' '}
								and our team applies its diverse and global experience to make
								software easy, impactful, and affordable for every business.
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default AboutUs;